import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ResourcesHero() {
  return <section className="relative pt-24 pb-32 px-4 overflow-hidden" data-id="element-737">
      <div className="absolute inset-0 z-0" data-id="element-738">
        <img src="https://cdn.magicpatterns.com/uploads/s3shiRa2hhBX6AL1FRhPki/resources-hero.jpg" alt="Resources Background" className="w-full h-full object-cover object-center" data-id="element-739" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/85 to-[#0f1f3d]/90" data-id="element-740"></div>
      </div>

      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-741">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-742">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-743">
            Resources
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-744"></div>
          <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-745">
            Training videos and guides for Northwest Black Belt Academy
            students.
          </p>
        </motion.div>
      </div>
    </section>;
}